import { migrations } from "@/app/store/migrations";
import termoNotificacaoReducer from "@/contexts/fiscalizacao/termoNotificacao/store/termoNotificacaoSlice";
import { configureStore } from "@reduxjs/toolkit";
import localforage from "localforage";
import { combineReducers } from "redux";
import { createMigrate, persistReducer, persistStore } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";

import usuarioLogadoReducer from "@/contexts/autorizacao/usuario/store/usuarioLogadoSlice";
import estabelecimentoReducer from "@/contexts/cadastro/estabelecimento/store/estabelecimentoSlice";
import servidorReducer from "@/contexts/cadastro/servidor/store/servidorSlice";
import formularioControleRespostaReducer from "@/contexts/fiscalizacao/formulario/store/formularioControleRespostaSlice";
import formularioReducer from "@/contexts/fiscalizacao/formulario/store/formularioSlice";
import relatorioAMReducer from "@/contexts/fiscalizacao/relatorioAM/store/relatorioAMSlice";
import requisicaoAnaliseReducer from "@/contexts/laboratorio/analiseLaboratorial/store/requisicaoAnaliseLaboratorialSlice";
import ensaioAnaliseReducer from "@/contexts/laboratorio/ensaioAnalise/store/ensaioAnaliseSlice";
import laboratorioReducer from "@/contexts/laboratorio/laboratorioAnalise/store/laboratorioAnaliseSlice";
import marcaProdutoReducer from "@/contexts/laboratorio/marcaProduto/store/marcaProdutoSlice";
import motivoNotificacaoReducer from "@/contexts/laboratorio/motivoNotificacao/store/motivoNotificacaoSlice";
import produtoAuorizadoReducer from "@/contexts/laboratorio/produtoAutorizado/store/produtoAutorizadoSlice";
import programacaoColetaAnaliseReducer from "@/contexts/laboratorio/programacaoColeta/store/programacaoColetaAnaliseSlice";
import menusReducer from "@/shared/menu/menuSlice";

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

const rootReducer = combineReducers({
  usuarioLogado: usuarioLogadoReducer,
  menus: menusReducer,
  requisicaoAnaliseLaboratorial: requisicaoAnaliseReducer,
  estabelecimento: estabelecimentoReducer,
  ensaioAnalise: ensaioAnaliseReducer,
  servidor: servidorReducer,
  produtoAutorizado: produtoAuorizadoReducer,
  marcaProduto: marcaProdutoReducer,
  programacaoColetaAnalise: programacaoColetaAnaliseReducer,
  motivoNotificacao: motivoNotificacaoReducer,
  termoNotificacao: termoNotificacaoReducer,
  formulario: formularioReducer,
  relatorioAM: relatorioAMReducer,
  formularioControleResposta: formularioControleRespostaReducer,
  laboratorio: laboratorioReducer,
});

localforage.config({
  name: "storage",
  size: 10080736,
  driver: localforage.INDEXEDDB,
  storeName: "INSPECAO_MOBILE",
  version: 1.0,
  description: "Armazenamento local do app Inspeção Mobile",
});

const persistConfig = {
  key: "root",
  storage: localforage,
  version: 3,
  blacklist: [],
  transforms: [],
  migrate: createMigrate(migrations, { debug: false }),
  stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer<ReturnType<typeof rootReducer>>(
  persistConfig,
  rootReducer
);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddlewares) => [
    ...getDefaultMiddlewares({
      serializableCheck: false,
      immutableCheck: { warnAfter: 128 },
    }),
  ],
});

export const persistor = persistStore(store);
